import React, { FC, useEffect, useRef, useState } from "react";
import { BACKEND_URL } from "constants"
import cogoToast from "cogo-toast";
import { Link, useNavigate } from "react-router-dom";
import CardNewspapper from "components/CardNewspapper/CardNewspapper"

// export interface SectionMagazine4Props extends SectionMagazine1Props {}

const SectionNewspappersAdmin = ({
  posts,
  className = "",
  category_id,
  category,
  subcategory_id,
  heading = "Latest Articles 🎈",
}) => {

  const navigate = useNavigate();

  const buttonClass =
    "nc-Button flex-shrink-0 relative h-auto inline-flex items-center justify-center rounded-full transition-colors border-transparent text-primary-50 text-sm sm:text-base font-medium py-3 px-4 sm:py-3.5 sm:px-6";


  const apiRequest = async (
      endpoint,
      method,
      id,
      successMessage,
      options = {}
    ) => {
      try {
        const response = await fetch(
          `${BACKEND_URL}/${endpoint}`,
          {
            method,
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ id }),
          }
        );
  
        const data = await response.json();
  
        if (data.statusCode === 200) {
          cogoToast.success(successMessage);
  
          if (options.navigateHome) {
            navigate("/");
          }
  
          if (options.reload) {
            window.location.reload();
          }
        }
      } catch (error) {
        console.error(error);
      }
    };

   const onDelete = (id) => {
    setTimeout(() => {
      apiRequest(
        "delete_newspappers",
        "POST",
        id,
        "Gazeta została usunięta",
        {
          reload: true,
        }
      );
    }, 2000);
  };


  return (
      <div className={`nc-SectionMagazine4 ${className}`}>
       {/* <div className="mobile-header"><HeaderFilter2 heading={heading} /></div>  */}
       <button className="subcategory-btn" style={{backgroundColor:'red', color:"white", marginTop:"10px", fontSize:"20px", marginBottom:'10px', width:"100%", border:"none", padding:"3px 3px 3px 3px"}}>Gazeta</button>
  
       {!posts.length && <span>Ładuje Gazety...</span>}
        <div 
        className="grid grid-cols-1 mb-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-6 md:gap-8"
        >
          {posts
            // .reverse()
            .map((item) => {
            return (
              <div style={{display:"flex", flexFlow:"column", justifyContent:'center', alignItems:"center", width:"100%"}} key={item.id}>
                <Link to={item?.pdf}>
                <h3 style={{fontSize:"22px", paddingBottom:"10px"}} className="mobile-font">{item?.title}</h3>
                </Link>
                {/* <span className="category-titles"  style={{color:"red",fontWeight:700}}><b>{item?.title}</b></span> */}
                <CardNewspapper key={item.id} post={item} />
                 <button
                onClick={() => {
                if (window.confirm("Czy na pewno chcesz usunąć tę gazetę?")) {
                  onDelete(item.id);
                  }
                }}
                className={buttonClass}
                style={{
                  marginTop: "10px",
                  width: "52%",
                  backgroundColor: "red",
                }}
              >
                Usuń gazetę
              </button>
                <hr className="mobile-line" style={{padding:"1px", marginTop:"20px", backgroundColor:"#ac8502"}}></hr>
              </div>
            )})}
            {/* {posts[10] && <Card8 category={category} className="sm:col-span-2" post={posts[10]} />} */}
        </div>
      </div>
    );
};

export default SectionNewspappersAdmin;
